<script lang="ts" setup>
const { data } = defineProps<{ data: EventOverview }>()
const businessRoute = getPublicRoute('businesses', { id: data.businessId, slug: data.businessSlug, name: data.businessName })
</script>

<template>
  <CollectionCard :data="data">
    <template #image>
      <ImageFull
        v-if="data.id && data.image && data.collectionId"
        :id="data.id"
        loading="lazy"
        :alt="data.name"
        :src="data.image"
        :collection-id="data.collectionId"
        class="w-full h-full object-cover"
      />
    </template>
    <template #aboveheading>
      <div class="flex gap-2 pb-3">
        <TextTag
          v-if="data.dateStart || data.dateEnd"
          class="font-display  gap-2 justify-between inline-flex"
        >
          <div
            v-if="data.dateStart"
            class="w-auto"
          >
            From <span class="font-semibold">{{ useDateFormat(data.dateStart, 'hh:mma D/MM/YY') }}</span>
          </div>
          <div
            v-if="data.dateStart && data.dateEnd"
            class="w-auto"
          >
            -
          </div>
          <div
            v-if="data.dateEnd"
            class="w-auto"
          >
            To <span class="font-semibold">{{ useDateFormat(data.dateEnd, 'hh:mma D/MM/YY') }}</span>
          </div>
        </TextTag>
      </div>
    </template>
    <template #underimage>
      <div
        v-if="data.businessId && data.businessName && data.businessSlug"
        class="flex flex-col justify-start px-3"
      >
        <p class=" text-white">
          Event by
        </p>
        <p class="text-lg text-white font-semibold leading-tight">
          <NuxtLink :to="businessRoute">
            {{ data.businessName }}
          </NuxtLink>
        </p>
      </div>
    </template>
    <template #heading>
      {{ data.name }}
    </template>
    <template #default>
      <div
        data-allow-mismatch
        v-html="normalizeNewlines(data.description)"
      />
    </template>
    <template #buttons="{ routeName }">
      <UButton
        v-if="data.businessId && data.businessName && data.businessSlug"
        :to="businessRoute"
        size="xl"
        trailing
        color="white"
      >
        View Business
        <UIcon
          name="heroicons:building-storefront"
          class="w-6 h-6 animate-pulse group-hover:animate-ping-pulse text-lightblue"
        />
      </UButton>
      <UButton
        :to="routeName"
        size="xl"
        trailing
      >
        View Event
        <Icon
          name="gbf:arrow-right"
          class="w-6 h-6 animate-pulse group-hover:animate-ping-pulse"
        />
      </UButton>
    </template>
  </CollectionCard>
</template>
